import React from 'react'
import { useNavigate } from 'react-router-dom';

import en from '../../../locales/en/translation.json';
import fr from '../../../locales/fr/translation.json';

import btnReturn from "../../../assets/logos/retourArrow.svg";

export default class Walletpage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lang: 'en',
            trad: en,
        }
    }

    render(){
        const {lang, trad} = this.state;
        return(
            <div className="wallet_page_faq">
                <div className="return">
                    <a href="#" onClick={() => navigate(-1)}>
                        <img src={btnReturn} alt=""/>
                        {trad.walletReturn}
                    </a>
                </div>
                <div className="titre">
                    <h1>{trad.walletTitle}</h1>
                </div>
                <div className="wallet_content">
                    <div className="wallet_content">
                        <h2>{trad.walletQuestion1}</h2>
                        <p>{trad.walletrep1}</p>
                        <p>{trad.walletrep2}</p>
                        <p>{trad.walletrep3}</p>
                    </div>
                    <div className="wallet_content">
                        <h2>{trad.walletQuestion2}</h2>
                        <p>{trad.walletrep4}</p>
                        <p>{trad.walletrep5}</p>
                        <p>{trad.walletrep6}</p>
                    </div>
                </div>
            </div>
        )
    }

}
